import OrderEditViewStore from '@components/order/stores/OrderEditViewStore';
import DirectionsWalkRoundedIcon from '@mui/icons-material/DirectionsWalkRounded';
import RestaurantMenuTwoToneIcon from '@mui/icons-material/RestaurantMenuTwoTone';
import { Box, Divider } from '@mui/material';
import { observer } from 'mobx-react-lite';
import React from 'react';
import UserAddressOptionListItem from './UserAddressOptionListItem';
import UserAddressEditViewStore from '../stores/UserAddressEditViewStore';
import PostAddTwoToneIcon from '@mui/icons-material/PostAddTwoTone';
import HomeTwoToneIcon from '@mui/icons-material/HomeTwoTone';
import BusinessTwoToneIcon from '@mui/icons-material/BusinessTwoTone';
import NoteTwoToneIcon from '@mui/icons-material/NoteTwoTone';

interface UserAddressOptionListProps {
    userAddressEditViewStore: UserAddressEditViewStore;
}

const UserAddressOptionList: React.FC<UserAddressOptionListProps> = observer(({ userAddressEditViewStore }) => {
    const { userAddressOption, setUserAddressOption } = userAddressEditViewStore;
    return (
        <Box display={"flex"} flexDirection={"row"} justifyContent={"space-between"}>
            <UserAddressOptionListItem
                title={"Novo"}
                icon={<PostAddTwoToneIcon />}
                value={"new"}
                selectedValue={userAddressOption}
                onClick={setUserAddressOption} />

                <Divider orientation='vertical' flexItem/>

            <UserAddressOptionListItem
                title={"Kuća"}
                icon={<HomeTwoToneIcon />}
                value={"home"}
                selectedValue={userAddressOption}
                onClick={setUserAddressOption} />

            <UserAddressOptionListItem
                title={"Posao"}
                icon={<BusinessTwoToneIcon />}
                value={"work"}
                selectedValue={userAddressOption}
                onClick={setUserAddressOption} />

            <UserAddressOptionListItem
                title={"Drugo"}
                icon={<NoteTwoToneIcon />}
                value={"other"}
                selectedValue={userAddressOption}
                onClick={setUserAddressOption} />
        </Box>
    )
})

export default UserAddressOptionList;